import type { RiskIndicator } from '@ballerine/common';

import { QuestionMarkTooltip } from '../QuestionMarkTooltip';

type CardSchemeRiskSectionProps = {
  findings: Array<Pick<RiskIndicator, 'id' | 'name'>>;
};

const MAX_VISIBLE_FINDINGS = 2;

export const CardSchemeRiskSection: React.FC<CardSchemeRiskSectionProps> = ({ findings }) => {
  const visibleFindings = findings.slice(0, MAX_VISIBLE_FINDINGS);
  const remainingCount = findings.length - MAX_VISIBLE_FINDINGS;

  return (
    <div className="mt-4">
      <div className="mb-3 flex items-center gap-1">
        <h4 className="text-sm font-semibold text-stone-400">CARD-SCHEME RISK</h4>
        <QuestionMarkTooltip
          text="Content findings related to card-scheme regulations and compliance requirements."
          className="ml-2"
        />
      </div>
      <div className="flex flex-col items-start gap-2 text-xs">
        {findings.length === 0 ? (
          <span className="inline-flex rounded-sm bg-green-100 px-1.5 py-0.5 text-green-700">
            Not Detected
          </span>
        ) : (
          <>
            {visibleFindings.map(finding => (
              <span
                key={finding.id}
                className="inline-flex w-fit rounded-sm bg-red-100 px-1.5 py-0.5 text-red-700"
                title={finding.name ?? undefined}
              >
                {finding.name ?? 'Unknown'}
              </span>
            ))}
            {remainingCount > 0 && (
              <span className="text-sm text-stone-400">
                + {remainingCount} additional finding{remainingCount > 1 ? 's' : ''}
              </span>
            )}
          </>
        )}
      </div>
    </div>
  );
};
